import React, { useState, useEffect } from "react";
import Card_operator from "./Card_operator";
import myConfig from "../../configs/config";
import MDSpinner from "react-md-spinner";
import axios from "axios";
import ExportButton from "../../components/Export_button";
import AddButton from "../../components/Add_button";
import { withTranslation } from "react-i18next";
import { isChildrenEmpty, normalizeApiList } from "../../helpers/utils";
import { useParams } from "react-router-dom";
import {
  FaClipboardList,
  FaMapMarkedAlt,
  FaHistory,
  FaRoute,
  FaHashtag,
  FaMobileAlt,
  FaInfoCircle,
} from "react-icons/fa";
import Modal from "@material-ui/core/Modal";
import BackButton from "../../components/BackButton";
import DeleteConfirmModal from "../../components/DeleteConfirmModal";
import OperatorPlanQuotaBar from "./OperatorPlanQuotaBar";
import PlanOperatorSelectionModal from "./PlanOperatorSelectionModal";
import SidebarToolInfoModal from "../../components/SidebarToolInfoModal";
import { usePendingOperatorAccess } from "../../contexts/PendingOperatorAccessContext";
import { toast, ToastContainer } from "react-toastify";
import "../../components/DeleteConfirmModal.css";
import "./ListOperator.css";

function ListOperator(props) {
  const params = useParams();
  const {
    pendingItems,
    ready: pendingReady,
    refreshPendingAccess,
    acknowledgeAccess,
  } = usePendingOperatorAccess();

  const [listOperators, setListOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [reloadKey, setReloadKey] = useState(0);
  const [planLimit, setPlanLimit] = useState(0);
  const [planStatus, setPlanStatus] = useState(null);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [farmIdInfoOpen, setFarmIdInfoOpen] = useState(false);
  const [licenseInfoOpen, setLicenseInfoOpen] = useState(false);
  const [deleteCandidate, setDeleteCandidate] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [planRefreshKey, setPlanRefreshKey] = useState(0);
  const [autoOpenedId, setAutoOpenedId] = useState(null);

  function handleComingSoon(event) {
    event.preventDefault();
    setComingSoonOpen(true);
  }

  async function handleLicenseSave(includedOperatorIds) {
    const limitToSave = planLimit > 0 ? planLimit : includedOperatorIds.length;
    await axios.post(
      `${myConfig.API_URL}/farm/${params.farm_id}/plan-operators/`,
      {
        plan_free_operators: limitToSave,
        included_operator_ids: includedOperatorIds,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      }
    );
    setReloadKey((value) => value + 1);
  }

  async function loadOperators({ showSpinner = true } = {}) {
    setLoadError("");
    if (showSpinner) {
      setLoading(true);
    }
    try {
      let OPERATOR_URL = `${myConfig.API_URL}/operator/?farm_id=${params.farm_id}`;

      const [operatorResponse, planResponse] = await Promise.all([
        axios({
          baseURL: OPERATOR_URL,
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("client-token")}`,
          },
        }),
        axios
          .get(`${myConfig.API_URL}/farm/${params.farm_id}/plan-operators/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("client-token")}`,
            },
          })
          .catch(() => ({ data: {} })),
      ]);

      setListOperators(normalizeApiList(operatorResponse.data));
      setPlanLimit(planResponse.data.plan_free_operators || 0);
      setPlanStatus(planResponse.data.plan_operator_status || null);
      refreshPendingAccess();
    } catch (error) {
      const status = error.response && error.response.status;
      if (status === 401 || status === 403) {
        setLoadError(
          "Sua sessão expirou ou você não tem permissão. Faça login novamente."
        );
      } else {
        setLoadError(
          "Falha ao carregar operadores. Verifique se a API está rodando e tente novamente."
        );
      }
    } finally {
      if (showSpinner) {
        setLoading(false);
      }
    }
  }

  function openDeleteConfirm(operator) {
    setDeleteCandidate(operator);
  }

  function closeDeleteConfirm() {
    if (deleting) return;
    setDeleteCandidate(null);
  }

  async function confirmDeleteOperator() {
    if (!deleteCandidate) return;

    const { id, nome } = deleteCandidate;
    setDeleting(true);
    try {
      await axios.delete(
        `${myConfig.API_URL}/operator/${id}/?farm_id=${params.farm_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("client-token")}`,
          },
        }
      );
      setListOperators((current) =>
        current.filter((operator) => operator.id !== id)
      );
      setDeleteCandidate(null);
      await loadOperators({ showSpinner: false });
      setPlanRefreshKey((value) => value + 1);
      toast.success(
        props.t("Operador {{name}} excluído com sucesso.", { name: nome }),
        { position: "bottom-right", autoClose: 3000 }
      );
    } catch (error) {
      toast.error(
        props.t("Não foi possível excluir o operador {{name}}.", {
          name: nome,
        }),
        { position: "bottom-right", autoClose: 5000 }
      );
    } finally {
      setDeleting(false);
    }
  }

  useEffect(() => {
    document.title = "Agriconnected - Operadores";
    loadOperators();
    const timer = setInterval(() => {
      loadOperators({ showSpinner: false });
    }, 5000);
    return () => clearInterval(timer);
  }, [reloadKey]);

  const visibleOperators = listOperators
    .map((operator) => {
      const pending = (pendingItems || []).find(
        (item) => String(item.operatorId) === String(operator.id)
      );
      if (!pending) {
        if (
          pendingReady &&
          operator.access_pending &&
          !operator.access_pending.acknowledged
        ) {
          return { ...operator, access_pending: null };
        }
        return operator;
      }
      return {
        ...operator,
        access_pending: {
          code: pending.code,
          expiresAt: pending.expiresAt,
          deviceId: pending.deviceId,
          acknowledged: Boolean(pending.acknowledged),
          expired: Boolean(pending.expired),
        },
      };
    })
    .sort((a, b) => {
      const rank = (operator) => {
        const pending = operator.access_pending;
        if (pending && pending.code && !pending.acknowledged) return 2;
        if (pending && pending.code) return 1;
        return 0;
      };
      return rank(b) - rank(a);
    });

  useEffect(() => {
    const wantsOpen =
      typeof window !== "undefined" &&
      /[?&]acesso=pendente/.test(window.location.search);
    if (!wantsOpen || autoOpenedId != null) {
      return;
    }
    const first = visibleOperators.find(
      (operator) =>
        operator.access_pending &&
        operator.access_pending.code &&
        !operator.access_pending.acknowledged
    );
    if (first) {
      setAutoOpenedId(first.id);
    }
  }, [visibleOperators, autoOpenedId]);

  async function handleAccessViewed(operator) {
    try {
      await acknowledgeAccess(operator.id);
      setAutoOpenedId("seen");
      setListOperators((current) =>
        current.map((item) =>
          item.id === operator.id && item.access_pending
            ? {
                ...item,
                access_pending: {
                  ...item.access_pending,
                  acknowledged: true,
                },
              }
            : item
        )
      );
    } catch (error) {
      toast.error(
        props.t("Não foi possível registrar que o código foi visto.")
      );
    }
  }

  return (
    <>
      {loading === false ? (
        <div id="operator_list_container">
          <div className="x_title">
            <BackButton to={`/${params.farm_id}`} label={props.t("Voltar")} />
            <h2>{props.t("Operadores")}</h2>
            <div className="clearfix"></div>
          </div>

          <div style={{ marginBottom: "20px" }}>
            <AddButton
              url={`/${params.farm_id}/operator/add`}
              classname="btn btn-primary btn-default-add"
            />
            <ExportButton
              classname="btn btn-default-export"
              export={`${myConfig.API_URL}/operator/export_operator/?farm_id=${params.farm_id}`}
            />
          </div>

          <OperatorPlanQuotaBar
            farmId={params.farm_id}
            refreshKey={`${reloadKey}-${planRefreshKey}`}
            onUpdated={() => setReloadKey((value) => value + 1)}
          />

          {/* Attendance Navigation Buttons */}
          <div
            style={{
              marginBottom: "20px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e0e0e0",
            }}
          >
            <h4 style={{ marginTop: 0, marginBottom: "15px", color: "#333" }}>
              {props.t("Sistema de Registro de Ponto")}
            </h4>
            <div className="operator-ponto-toolbar">
              <div className="operator-ponto-toolbar__actions">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleComingSoon}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 20px",
                  }}
                >
                  <FaClipboardList />
                  {props.t("Painel de Ponto")}
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleComingSoon}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 20px",
                  }}
                >
                  <FaMapMarkedAlt />
                  {props.t("Mapa de Presença")}
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleComingSoon}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 20px",
                  }}
                >
                  <FaHistory />
                  {props.t("Histórico de Ponto")}
                </button>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleComingSoon}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 20px",
                  }}
                >
                  <FaRoute />
                  {props.t("Histórico de Localização")}
                </button>
              </div>
              <div className="operator-ponto-toolbar__meta">
                <button
                  type="button"
                  className="operator-ponto-chip"
                  onClick={() => setFarmIdInfoOpen(true)}
                >
                  <FaHashtag />
                  <span>
                    <span className="operator-ponto-chip__label">
                      {props.t("ID da fazenda")}
                    </span>{" "}
                    <span className="operator-ponto-chip__value">
                      {params.farm_id}
                    </span>
                  </span>
                  <FaInfoCircle className="operator-ponto-chip__info" />
                </button>
                <button
                  type="button"
                  className="operator-ponto-chip"
                  onClick={() => setLicenseInfoOpen(true)}
                >
                  <FaMobileAlt />
                  <span>
                    <span className="operator-ponto-chip__label">
                      {props.t("Licenças do app")}
                    </span>{" "}
                    <span className="operator-ponto-chip__value">
                      {planStatus
                        ? props.t("{{used}} de {{limit}}", {
                            used: planStatus.included_count,
                            limit: planStatus.limit,
                          })
                        : planLimit}
                    </span>
                  </span>
                  <FaInfoCircle className="operator-ponto-chip__info" />
                </button>
              </div>
            </div>
          </div>

          {farmIdInfoOpen ? (
            <SidebarToolInfoModal
              title={props.t("ID da fazenda")}
              onClose={() => setFarmIdInfoOpen(false)}
            >
              <p>
                {props.t("O ID desta fazenda é {{farmId}}.", {
                  farmId: params.farm_id,
                })}
              </p>
              <p>
                {props.t(
                  "No aplicativo, o operador deve informar este ID da fazenda e os 6 primeiros dígitos do CPF cadastrado."
                )}
              </p>
            </SidebarToolInfoModal>
          ) : null}

          {licenseInfoOpen ? (
            <PlanOperatorSelectionModal
              operators={listOperators}
              limit={
                planLimit > 0
                  ? planLimit
                  : Math.max(listOperators.length, 1)
              }
              title={props.t("Licenças do aplicativo")}
              description={props.t(
                "As licenças do app são cobradas por acesso. Você pode cadastrar mais operadores do que o número de licenças. Se houver 5 licenças, escolha os 5 operadores que poderão enviar informações pelo aplicativo."
              )}
              onClose={() => setLicenseInfoOpen(false)}
              onSave={handleLicenseSave}
            />
          ) : null}

          <Modal
            open={comingSoonOpen}
            onClose={() => setComingSoonOpen(false)}
            aria-labelledby="attendance-coming-soon-title"
          >
            <div
              className="delete-confirm-modal"
              onClick={(event) => event.stopPropagation()}
            >
              <h2 id="attendance-coming-soon-title">
                {props.t("Em desenvolvimento")}
              </h2>
              <p>
                {props.t(
                  "Esta função ainda está em desenvolvimento e não será liberada neste momento."
                )}
              </p>
              <div className="delete-confirm-modal__actions">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setComingSoonOpen(false)}
                >
                  {props.t("Entendi")}
                </button>
              </div>
            </div>
          </Modal>

          {loadError ? (
            <div className="alert alert-danger" role="alert">
              {loadError}
            </div>
          ) : null}

          <DeleteConfirmModal
            open={Boolean(deleteCandidate)}
            title={props.t("Excluir operador")}
            message={
              deleteCandidate
                ? props.t(
                    "Deseja realmente excluir o operador {{name}}? Esta ação remove o cadastro e não pode ser desfeita.",
                    { name: deleteCandidate.nome }
                  )
                : ""
            }
            confirmLabel={props.t("Excluir")}
            cancelLabel={props.t("Cancelar")}
            onConfirm={confirmDeleteOperator}
            onCancel={closeDeleteConfirm}
            loading={deleting}
          />

          <DeleteConfirmModal
            open={Boolean(deleteCandidate)}
            title={props.t("Excluir operador")}
            message={
              deleteCandidate
                ? props.t(
                    "Deseja realmente excluir o operador {{name}}? Esta ação remove o cadastro e não pode ser desfeita.",
                    { name: deleteCandidate.nome }
                  )
                : ""
            }
            confirmLabel={props.t("Excluir")}
            cancelLabel={props.t("Cancelar")}
            onConfirm={confirmDeleteOperator}
            onCancel={closeDeleteConfirm}
            loading={deleting}
          />

          {isChildrenEmpty(
            visibleOperators,
            <div>
              <h4 align="center">
                Está fazenda ainda não possui nenhum operador cadastrado
              </h4>
            </div>,
            <div>
              {visibleOperators.map((operator) => (
                <Card_operator
                  operator={operator}
                  key={operator.id}
                  farm_id={params.farm_id}
                  showPlanBadges={planLimit > 0 || operator.plan_included}
                  onRequestDelete={openDeleteConfirm}
                  autoOpenAccess={autoOpenedId === operator.id}
                  onAccessViewed={handleAccessViewed}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div
          style={{ marginTop: "50px", marginLeft: "50%", minHeight: "200px" }}
        >
          <MDSpinner />
        </div>
      )}
      <ToastContainer position="bottom-right" />
    </>
  );
}
export default withTranslation()(ListOperator);
